// extracted by mini-css-extract-plugin
export var content = "Interview-module--content--qoJE7";
export var image = "Interview-module--image--oXO80";
export var imageWrapper = "Interview-module--imageWrapper--buB86";
export var question = "Interview-module--question--G5R-T";
export var subtitle = "Interview-module--subtitle--wLiXe";
export var title = "Interview-module--title--1MzZ+";